import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { type ArtBoardMode, artBoardActions } from '@store/reducers/artboard'
import { useDispatch, useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'

export const useSettings = () => {
  const dispatch = useDispatch()
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const { settings, activityHistory, storage, color, symbolLibrary } =
    useArtboardMode()

  const active =
    settings || activityHistory || storage || color || symbolLibrary

  const onClick = () => {
    const mode: ArtBoardMode = active ? 'edit' : 'settings'
    dispatch(artBoardActions.changeMode(mode))
  }

  return {
    canEdit,
    active,
    onClick,
  }
}
